import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import { Box } from '@mui/material';
import { FontVariantToken } from '@uipath/apollo-core';
import React from 'react';

interface StepHeaderProps {
    title: string;
    description: string;
}

export const GovernancePolicyStepHeader: React.FC<StepHeaderProps> = ({
    title,
    description,
}) => (
    <UiStack
        direction="column"
        data-cy="governance-policy-step-header"
        mb={SpacingToken.M}
    >
        <Box sx={{ mb: 1 }}>
            <UiText
                variant={FontVariantToken.fontSizeH3Bold}
                data-cy="governance-policy-step-title"
            >
                {title}
            </UiText>
        </Box>
        <Box>
            <UiText
                variant={FontVariantToken.fontSizeL}
                color="var(--color-foreground-de-emp)"
                data-cy="governance-policy-step-description"
            >
                {description}
            </UiText>
        </Box>
    </UiStack>
);
